import LZString from 'lz-string';

export const lzCompress = (value: unknown): string =>
  LZString.compressToEncodedURIComponent(JSON.stringify(value));

export const lzDecompress = (str: string | null): unknown => {
  if (!str) return null;
  try {
    const json = LZString.decompressFromEncodedURIComponent(str);
    return json ? JSON.parse(json) : null;
  } catch {
    return null;
  }
};
